// Current prices for BrandEasy (Dez. 2020)
const MIN_PRICE_BRAND_EASY = 0.2735 // 7000 jobs
const MAX_PRICE_BRAND_EASY = 0.3222 // 3000 jobs

function generationCostsBrandEasy (materials) {
  const min = Math.round(MIN_PRICE_BRAND_EASY * materials)
  const max = Math.round(MAX_PRICE_BRAND_EASY * materials)
  return { min, max }
}

function generationCostsCreatify (materials) {
  const min = Math.round(0.5 * materials)
  return { min, max: min }
}

function generationCosts ({ creatifyMaterials, brandEasyMaterials }) {
  const { min, max } = generationCostsBrandEasy(brandEasyMaterials)
  const { min: minCreatify, max: maxCreatify } = generationCostsCreatify(creatifyMaterials)
  return { min: min + minCreatify, max: max + maxCreatify }
}

export {
  generationCosts,
  generationCostsCreatify,
  generationCostsBrandEasy
}
